export default __webpack_public_path__ + "static/media/backgroundLogo.04da1bc6.svg";